export { FriendsTab } from './FriendsTab.tsx';
